import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';
import Utils from '../../../utils/Utils';

class MultiPurchaseButtonInfo extends AbstractRequestTask {
    constructor(groupIds = '', withoutToken = false) {
        super();
        this.group_ids = groupIds;
        this.withoutToken = withoutToken;
    }

    getHeaders() {
        const params = super.getParams();
        if(params.user_token) {
            return {
                'Authorization': 'Bearer ' + params.user_token
            };
        } else {
            return {};
        }
    }

    getEncType() {
        return 'multipart/form-data';
    }

    getUrl() {
        const http = "https://";
        const url = Launcher.get("akamai_mfwk");
        let _url = `${http}${url}/services/payway/paymentservice/v1/multipurchasebuttoninfo?`;
        _url += Utils.buildQueryParams(this.getGETParams());
        return _url;
    }

    getMethod() {
        return 'POST';
    }

    getParams() {
        const params = {};
        params.extra_params = JSON.stringify({group_ids: this.group_ids});
        return params;
    }

    getShowErrorModal() {
        return false;
    }

    getGETParams() {
        const params = super.getParams();
        delete params.HKS;
        delete params.api_version;
        delete params.user_token;
        return params;
    }

    getRetriesNumber() {
        return 0;
    }

    success(data, b) {
        this.resolve(data);
    }

    isValid(data) {
        if(data.errors || !data.data || !data.data.listButtons) {
            return false;
        }
        return true;
    }

}

export default MultiPurchaseButtonInfo;



// WEBPACK FOOTER //
// ./src/requests/tasks/search/MultiPurchaseButtonInfo.jsx